(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPricingTrimSelector", [
    "$timeout",
    "DebugLogger",
    function ($timeout, DebugLogger) {
      function handleReject(error) {
        DebugLogger.log("tyPricingTrimSelector", error);
      }

      var controller = [
        "$scope",
        "$attrs",
        "$q",
        "HttpPendingRequestsService",
        "Range",
        "RangeSorting",
        "PricingPageAnalyticsService",
        function ($scope, $attrs, $q, HttpPendingRequestsService, Range, RangeSorting, PricingPageAnalyticsService) {
          var ctl = this;
          var firstPass = true;
          var getTrimsByVariantIdComplete = false;

          $scope.trim = {
            trimGroups: [],
            selectedTrimCode: "",
            selectedTrimName: "",
            selectedTrimNameDisplay: "",
            isLoading: false,
          };

          function init() {
            DebugLogger.log(
              "tyPricingTrimSelector",
              "init -> initialTrimId is " + $scope.tyPricingTrimSelectorController.initialTrimId
            );

            $scope.$on("variant-changed", function (event, pricingPageVariantIdsChangedData) {
              if (
                pricingPageVariantIdsChangedData.grade &&
                !pricingPageVariantIdsChangedData.grade.containsOptionPacks
              ) {
                onVariantChange(pricingPageVariantIdsChangedData);
              }
            });

            $scope.$on("option-pack-changed", function (event, pricingPageOptionPackChangedData) {
              if (
                pricingPageOptionPackChangedData.grade &&
                pricingPageOptionPackChangedData.grade.containsOptionPacks
              ) {
                onVariantChange(pricingPageOptionPackChangedData);
              }
            });

            $scope.$watch("$parent.pricingPage.loading", function (newValue) {
              DebugLogger.log("tyPricingTrimSelector", "trim caught loading change: ", newValue);
            });

            $scope.$watch("$parent.pricingPage.loading", function (newValue) {
              DebugLogger.log("tyPricingTrimSelector", "paint caught loading change: ", newValue);
              if (newValue === false) {
                $scope.trim.isLoading = !getTrimsByVariantIdComplete;
              } else {
                $scope.trim.isLoading = true;
              }
            });

            $scope.$on("paint-changed", function (event, promise) {
              promise
                .then(function (pricingPagePaintChangedData) {
                  onPaintChange(pricingPagePaintChangedData.paintId, pricingPagePaintChangedData.pricingParams);
                })
                .catch(handleReject);
            });

            ctl.saveTrimCode = function () {
              $scope.trim.savedTrimCode = $scope.trim.selectedTrimCode;
              setSelectedTrimByTrimCode($scope.trim.selectedTrimCode, "trim", "active");
            };
          }

          function getTrimGroupByTrimCode(trimCode) {
            return $scope.trim.trimGroups.find(function (trimGroup) {
              return trimGroup.TrimCode === trimCode;
            });
          }

          function getTrimIdsByTrimCode(trimCode) {
            return getTrimGroupByTrimCode(trimCode).trims.map(function (trim) {
              return trim.ID;
            });
          }

          function emitChange(source) {
            if (source !== "grade") {
              HttpPendingRequestsService.cancelAll();
            }

            var pricingPageTrimChangedData = {
              grade: $scope.trim.eventData.grade,
              variantIds: $scope.trim.eventData.variantIds,
              trimIds: getTrimIdsByTrimCode($scope.trim.selectedTrimCode),
              source: source,
            };

            ctl.onTrimsChange(pricingPageTrimChangedData);
          }

          function trimsToSwatches(trims) {
            return trims.map(function (trim) {
              return angular.extend({}, trim, {
                id: trim.TrimCode,
                description: trim.TrimDescription,
                hex: "#000000",
                image: trim.TrimImage,
              });
            });
          }

          function onVariantChange(pricingPageVariantIdsChangedData) {
            DebugLogger.log("tyPricingTrimSelector", "trim onVariantChange: ", pricingPageVariantIdsChangedData);
            $scope.trim.isLoading = true;

            $scope.trim.eventData = pricingPageVariantIdsChangedData;

            Range.getTrimGroupsByVariantIds(pricingPageVariantIdsChangedData.variantIds)
              .then(function (trimGroups) {
                $scope.trim.trimGroups = trimGroups;
                $scope.trim.ordering = trimGroups.map(function (trimGroup) {
                  return trimGroup.TrimDescription;
                });
                passiveUpdateSelectedTrimCode();
                getTrimsByVariantIdComplete = true;
              })
              .catch(function (error) {
                $scope.tyPricingPage.handleError(error);
              });
          }

          function onPaintChange(paintId) {
            var currentPaint = Range.getRoofPaintByIdFromCache(paintId);
            var parentTrimCode = currentPaint.ParentTrimCode;
            var availableTrimCodes = currentPaint.AvailableTrims
              ? currentPaint.AvailableTrims.map(function (trim) {
                  return trim.TrimCode;
                })
              : [];

            var visibleTrimGroups = $scope.trim.trimGroups.filter(function (trimGroup) {
              return (
                availableTrimCodes.find(function (availableTrimCode) {
                  return trimGroup.TrimCode === availableTrimCode;
                }) || trimGroup.TrimCode === parentTrimCode
              );
            });

            $scope.trim.trimSwatches = trimsToSwatches(visibleTrimGroups);
          }

          function passiveUpdateSelectedTrimCode() {
            var trim = getSelectedTrim();

            if (trim) {
              setSelectedTrimByTrimCode(trim.TrimCode, $scope.trim.eventData.source, "passive");
            }
          }

          function setSelectedTrimByTrimCode(trimCode, eventSource, passiveOrActive) {
            var trimGroup = getTrimGroupByTrimCode(trimCode);
            $scope.trim.selectedTrimCode = trimCode;
            $scope.trim.selectedTrimName = trimGroup.TrimDescription;

            emitChange(eventSource);

            PricingPageAnalyticsService.setTrim(trimGroup.TrimDescription);

            if (passiveOrActive === "active") {
              triggerTrimActiveSelectionAnalyticsEvent(trimGroup.TrimDescription);
            }
          }

          $scope.trim.setTrimByTrimCode = function (trimCode) {
            setSelectedTrimByTrimCode(trimCode, $scope.trim.eventData.source, "active");
          };

          function getSelectedTrim() {
            var trim;

            if (firstPass) {
              firstPass = false;

              if (ctl.initialTrimId) {
                trim = Range.getTrimByIdFromCache(ctl.initialTrimId);
              }
            } else {
              var previousTrimName = $scope.trim.selectedTrimName;
              trim = $scope.trim.trimGroups.find(function (trimGroup) {
                return trimGroup.TrimDescription === previousTrimName;
              });
            }

            return trim || $scope.trim.trimGroups[0].trims[0];
          }

          function triggerTrimActiveSelectionAnalyticsEvent(trim) {
            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "button - trim paint swatch",
              eventLabel: trim,
            });
          }

          ctl.$onInit = init;
        },
      ];

      var link = function ($scope, $element) {
        DebugLogger.log(
          "tyPricingTrimSelector",
          "link -> initialTrimId is " + $scope.tyPricingTrimSelectorController.initialTrimId
        );

        var $trimDescription = $element.find("[data-ty-pricing-trim-selector-option-description]");
        $scope.$watch("trim.selectedTrimName", function () {
          $trimDescription.fadeOut(function () {
            $timeout(function () {
              $scope.trim.selectedTrimNameDisplay = $scope.trim.selectedTrimName;
              $trimDescription.fadeIn();
            });
          });
        });
      };

      return {
        bindToController: {
          initialTrimId: "<tyPricingTrimSelectorInitialTrimId",
          onTrimsChange: "<tyPricingTrimSelectorOnTrimsChange",
        },
        scope: true,
        restrict: "A",
        controller: controller,
        controllerAs: "tyPricingTrimSelectorController",
        link: link,
      };
    },
  ]);
})(window.angular);
